import BaseAPI from './base/base-api';

class ProductsAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'Products';
}

export default new ProductsAPI();